import { getPartnerDrawerUrl } from '@/services/partner-links';
import { getCommunicationContactReference } from '@bariendo/lib/communication';
import { TIMELINE_FOCUS_ITEM_QUERY_PARAM } from '@bariendo/lib/constants';
import { isReferenceOf } from '@bariendo/lib/services';
import { getReferenceString, resolveId } from '@medplum/core';
import { Communication } from '@medplum/fhirtypes';

/**
 * Where a Phone logs or SMS logs row click goes, or `undefined` for a row that is inert.
 *
 * A patient row opens the timeline focused on the communication, when the reader can see the
 * patient (a reference whose `resource` did not resolve is a chart they cannot open). A
 * partner row opens the Organizations drawer, but only for a reader with partner access; for
 * anyone else that page bounces them off an access-denied alert. An unknown number has
 * nowhere to go at all, and used to land on `/Organizations?expand=undefined`. The row
 * actions are what those rows offer.
 */
export function getRowNavigationUrl(communication: Communication, hasPartnerAccess: boolean): string | undefined {
  const contact = getCommunicationContactReference(communication);
  if (isReferenceOf(contact, 'Patient')) {
    if (!contact?.resource) {
      return undefined;
    }
    const focus = encodeURIComponent(getReferenceString(communication) ?? '');
    return `/Patient/${resolveId(contact)}/timeline?${TIMELINE_FOCUS_ITEM_QUERY_PARAM}=${focus}`;
  }
  if (isReferenceOf(contact, 'Organization')) {
    return getPartnerDrawerUrl(resolveId(contact), hasPartnerAccess);
  }
  return undefined;
}
